export const blogPosts = [
  {
    id: 1,
    slug: 'tente-bakimi-nasil-yapilir',
    title: 'Tente Bakımı Nasıl Yapılır? Uzun Ömürlü Kullanım İçin İpuçları',
    excerpt: 'Tentelerinizin uzun ömürlü olması için düzenli bakım şarttır. İşte profesyonel tente bakım ipuçları.',
    category: 'Bakım',
    date: '2024-12-15',
    author: 'İzmir Tente Tamir',
    image: 'https://public.readdy.ai/ai/img_res/cb32b796a737898f6583eab406dfc608.jpg',
    content: `
      <p>Tenteler, güneş ışığı, yağmur ve rüzgar gibi dış etkenlerle sürekli temas halinde olduğu için düzenli bakım gerektirir. Doğru bakım yöntemleriyle tentenizin ömrünü uzatabilir ve her zaman yeni gibi görünmesini sağlayabilirsiniz.</p>

      <h2>Düzenli Temizlik</h2>
      <p>Tente bakımının en önemli adımı düzenli temizliktir. Branda üzerinde biriken kir, toz ve organik maddeler zamanla kumaşa zarar verebilir.</p>
      <ul>
        <li>Ayda bir kez yumuşak bir fırça ile kuru temizlik yapın</li>
        <li>Üç ayda bir ılık su ve yumuşak sabunla yıkayın</li>
        <li>Yüksek basınçlı su kullanmaktan kaçının</li>
        <li>Temizlik sonrası tenteyi tamamen kurumasını bekleyin</li>
      </ul>

      <h2>Mekanizma Bakımı</h2>
      <p>Tente mekanizmasının düzgün çalışması için periyodik bakım şarttır:</p>
      <ul>
        <li>Yılda iki kez tüm hareketli parçaları yağlayın</li>
        <li>Vidaları ve bağlantı noktalarını kontrol edin</li>
        <li>Kollar ve mafsallarda gevşeme olup olmadığını inceleyin</li>
        <li>Motor sistemlerinde elektrik bağlantılarını kontrol ettirin</li>
      </ul>

      <h2>Kış Hazırlığı</h2>
      <p>Kış aylarında tentelerinizi korumak için:</p>
      <ul>
        <li>Kar yağışı öncesi tenteyi kapatın</li>
        <li>Uzun süre kullanmayacaksanız brandayı sökmeyi düşünün</li>
        <li>Fırtınalı havalarda tenteyi açık bırakmayın</li>
        <li>Kış sonunda profesyonel kontrol yaptırın</li>
      </ul>

      <h2>Küf ve Leke Önleme</h2>
      <p>Nemli havalarda küf oluşumunu önlemek için:</p>
      <ul>
        <li>Tenteyi ıslakken kapatmayın</li>
        <li>Düzenli havalandırma yapın</li>
        <li>Küf önleyici ürünler kullanın</li>
        <li>Lekeleri hemen temizleyin</li>
      </ul>

      <h2>Profesyonel Bakım</h2>
      <p>Yılda en az bir kez profesyonel bakım hizmeti alın. Uzman ekipler, gözle görülmeyen sorunları tespit edebilir ve büyük arızaları önleyebilir.</p>

      <p>İzmir Tente Tamir olarak, tente bakım hizmetleri sunuyoruz. Düzenli bakım anlaşmalarımız hakkında bilgi almak için bizi arayabilirsiniz.</p>
    `
  },
  {
    id: 2,
    slug: 'dogru-tente-secimi-nasil-yapilir',
    title: 'Doğru Tente Seçimi Nasıl Yapılır? Kapsamlı Rehber',
    excerpt: 'İhtiyacınıza uygun tente seçimi yaparken nelere dikkat etmelisiniz? İşte detaylı tente seçim rehberi.',
    category: 'Rehber',
    date: '2024-12-10',
    author: 'İzmir Tente Tamir',
    image: 'https://readdy.ai/api/search-image?query=variety%20of%20different%20awning%20types%20displayed%20on%20modern%20building%2C%20multiple%20tent%20styles%20comparison%2C%20professional%20installation%20showcase%2C%20bright%20daylight%20photography%2C%20clean%20commercial%20setting%20with%20simple%20background%2C%20quality%20awning%20selection%20guide&width=800&height=500&seq=blog2&orientation=landscape',
    content: `
      <p>Tente seçimi, hem estetik hem de fonksiyonel açıdan önemli bir karardır. Doğru tente, size yıllarca hizmet ederken, yanlış seçim hayal kırıklığı yaratabilir. İşte doğru tente seçimi için kapsamlı rehberimiz.</p>

      <h2>Kullanım Alanını Belirleyin</h2>
      <p>İlk adım, tenteyi nerede kullanacağınızı belirlemektir:</p>
      <ul>
        <li><strong>Konut Balkonları:</strong> Mafsallı veya körüklü tenteler ideal</li>
        <li><strong>Bahçe ve Teraslar:</strong> Geniş açılımlı mafsallı tenteler</li>
        <li><strong>Ticari Mekanlar:</strong> Körüklü tenteler marka kimliği için uygun</li>
        <li><strong>Havuz Kenarları:</strong> Su geçirmez özellikli tenteler</li>
      </ul>

      <h2>Tente Türlerini Tanıyın</h2>
      <h3>Mafsallı Tenteler</h3>
      <p>Kollar üzerinde mafsallarla açılan, geniş gölgelendirme alanı sağlayan sistemler. Modern ve fonksiyoneldir.</p>

      <h3>Körüklü Tenteler</h3>
      <p>Klasik ve estetik görünümlü, özellikle ticari mekanlar için idealdir. Marka kimliği taşıyabilir.</p>

      <h3>Pergola Sistemleri</h3>
      <p>Sabit ve dayanıklı, bahçe ve teraslar için uzun ömürlü çözüm sunar.</p>

      <h2>Manuel mi Motorlu mu?</h2>
      <p>Kullanım kolaylığı ve bütçenize göre seçim yapın:</p>
      <ul>
        <li><strong>Manuel Tenteler:</strong> Ekonomik, basit, az bakım gerektirir</li>
        <li><strong>Motorlu Tenteler:</strong> Kolay kullanım, uzaktan kontrol, büyük tenteler için ideal</li>
        <li><strong>Sensörlü Sistemler:</strong> Akıllı kontrol, otomatik açılma-kapanma</li>
      </ul>

      <h2>Kumaş Seçimi</h2>
      <p>Branda kumaşı, tentenizin ömrünü ve performansını belirler:</p>
      <ul>
        <li><strong>Akrilik Kumaş:</strong> UV dayanımlı, renk solması yapmaz, uzun ömürlü</li>
        <li><strong>PVC Branda:</strong> Su geçirmez, ekonomik, dayanıklı</li>
        <li><strong>Polyester:</strong> Hafif, esnek, uygun fiyatlı</li>
      </ul>

      <h2>Renk ve Desen</h2>
      <p>Estetik tercihleriniz kadar fonksiyonel özellikler de önemlidir:</p>
      <ul>
        <li>Açık renkler güneş ışığını daha iyi yansıtır</li>
        <li>Koyu renkler daha fazla gölge sağlar</li>
        <li>Çizgili desenler klasik ve şık görünüm verir</li>
        <li>Düz renkler modern ve minimalist tarz için uygundur</li>
      </ul>

      <h2>Bütçe Planlaması</h2>
      <p>Tente yatırımı yaparken sadece ilk maliyeti değil, uzun vadeli maliyetleri de düşünün:</p>
      <ul>
        <li>Kaliteli malzeme daha uzun ömürlüdür</li>
        <li>Motorlu sistemler daha yüksek ilk maliyete sahiptir</li>
        <li>Düzenli bakım maliyetlerini hesaba katın</li>
        <li>Garanti süresi ve koşullarını inceleyin</li>
      </ul>

      <h2>Profesyonel Danışmanlık</h2>
      <p>Doğru seçim yapmak için profesyonel danışmanlık alın. İzmir Tente Tamir olarak, ücretsiz keşif ve danışmanlık hizmeti sunuyoruz. İhtiyaçlarınızı dinliyor ve size en uygun çözümü öneriyoruz.</p>
    `
  },
  {
    id: 3,
    slug: 'tente-ariza-turleri-ve-cozumleri',
    title: 'Tente Arıza Türleri ve Çözümleri: Kapsamlı Kılavuz',
    excerpt: 'Tentelerinizde karşılaşabileceğiniz yaygın arızalar ve çözüm yöntemleri hakkında bilmeniz gerekenler.',
    category: 'Tamir',
    date: '2024-12-05',
    author: 'İzmir Tente Tamir',
    image: 'https://readdy.ai/api/search-image?query=awning%20repair%20diagnostic%20process%2C%20technician%20examining%20tent%20mechanism%20problem%2C%20detailed%20troubleshooting%20work%2C%20professional%20service%20photography%2C%20bright%20daylight%2C%20clean%20commercial%20setting%20with%20simple%20background&width=800&height=500&seq=blog3&orientation=landscape',
    content: `
      <p>Tenteler, kullanım sırasında çeşitli arızalarla karşılaşabilir. Bu arızaların erken tespiti ve doğru müdahale, büyük hasarları önler. İşte en yaygın tente arızaları ve çözüm yöntemleri.</p>

      <h2>Branda Sorunları</h2>
      <h3>Yırtık ve Delikler</h3>
      <p><strong>Belirtiler:</strong> Branda üzerinde görünen yırtıklar, delikler veya aşınmalar</p>
      <p><strong>Nedenler:</strong> Hava koşulları, fiziksel darbe, yaşlanma</p>
      <p><strong>Çözüm:</strong> Küçük yırtıklar onarılabilir, büyük hasarlarda branda değişimi gerekir</p>

      <h3>Renk Solması</h3>
      <p><strong>Belirtiler:</strong> Brandanın rengi solmuş, canlılığını kaybetmiş</p>
      <p><strong>Nedenler:</strong> UV ışınları, düşük kaliteli kumaş</p>
      <p><strong>Çözüm:</strong> Branda değişimi, kaliteli UV dayanımlı kumaş seçimi</p>

      <h3>Su Geçirgenliği</h3>
      <p><strong>Belirtiler:</strong> Branda su geçirmeye başlamış</p>
      <p><strong>Nedenler:</strong> Kumaş eskimesi, su itici özelliğin kaybolması</p>
      <p><strong>Çözüm:</strong> Su itici sprey uygulaması veya branda değişimi</p>

      <h2>Mekanizma Arızaları</h2>
      <h3>Açılma-Kapanma Zorluğu</h3>
      <p><strong>Belirtiler:</strong> Tente zor açılıyor veya kapanıyor</p>
      <p><strong>Nedenler:</strong> Yağlama eksikliği, kir birikimi, yay zayıflaması</p>
      <p><strong>Çözüm:</strong> Mekanizma temizliği ve yağlanması, yay değişimi</p>

      <h3>Kol ve Mafsallarda Kırılma</h3>
      <p><strong>Belirtiler:</strong> Kollar bükülmüş veya kırılmış</p>
      <p><strong>Nedenler:</strong> Aşırı rüzgar, fiziksel darbe, metal yorgunluğu</p>
      <p><strong>Çözüm:</strong> Hasarlı parçaların değiştirilmesi</p>

      <h3>Tente Sabitlenmiyor</h3>
      <p><strong>Belirtiler:</strong> Tente açıldığında istenilen pozisyonda durmuyor</p>
      <p><strong>Nedenler:</strong> Yay arızası, kilit mekanizması sorunu</p>
      <p><strong>Çözüm:</strong> Yay değişimi, kilit mekanizması tamiri</p>

      <h2>Motorlu Tente Arızaları</h2>
      <h3>Motor Çalışmıyor</h3>
      <p><strong>Belirtiler:</strong> Kumandaya basıldığında motor tepki vermiyor</p>
      <p><strong>Nedenler:</strong> Elektrik kesintisi, motor arızası, kumanda pil sorunu</p>
      <p><strong>Çözüm:</strong> Elektrik bağlantıları kontrolü, motor testi, kumanda pil değişimi</p>

      <h3>Motor Çalışıyor Ama Tente Hareket Etmiyor</h3>
      <p><strong>Belirtiler:</strong> Motor sesi geliyor ama tente açılmıyor</p>
      <p><strong>Nedenler:</strong> Mekanik bağlantı kopması, dişli arızası</p>
      <p><strong>Çözüm:</strong> Mekanik bağlantıların kontrolü ve tamiri</p>

      <h3>Kumanda Çalışmıyor</h3>
      <p><strong>Belirtiler:</strong> Uzaktan kumanda ile kontrol edilemiyor</p>
      <p><strong>Nedenler:</strong> Pil bitmiş, kumanda eşleşmesi bozulmuş</p>
      <p><strong>Çözüm:</strong> Pil değişimi, kumanda yeniden programlama</p>

      <h2>Montaj ve Sabitleme Sorunları</h2>
      <h3>Tente Sallanıyor</h3>
      <p><strong>Belirtiler:</strong> Rüzgarda aşırı sallanma</p>
      <p><strong>Nedenler:</strong> Gevşek montaj, yetersiz sabitleme</p>
      <p><strong>Çözüm:</strong> Montaj noktalarının sıkılaştırılması, ek destek eklenmesi</p>

      <h3>Duvarda Çatlak</h3>
      <p><strong>Belirtiler:</strong> Montaj noktalarında duvar çatlakları</p>
      <p><strong>Nedenler:</strong> Yetersiz duvar mukavemeti, aşırı yük</p>
      <p><strong>Çözüm:</strong> Duvar takviyesi, montaj noktalarının yeniden belirlenmesi</p>

      <h2>Önleyici Bakım</h2>
      <p>Arızaları önlemek için düzenli bakım şarttır:</p>
      <ul>
        <li>Ayda bir genel kontrol yapın</li>
        <li>Üç ayda bir mekanizmayı yağlayın</li>
        <li>Yılda bir profesyonel bakım yaptırın</li>
        <li>Fırtınalı havalarda tenteyi kapatın</li>
        <li>Küçük sorunları hemen giderin</li>
      </ul>

      <h2>Ne Zaman Profesyonel Yardım Almalı?</h2>
      <p>Aşağıdaki durumlarda profesyonel yardım alın:</p>
      <ul>
        <li>Motor arızaları</li>
        <li>Yapısal hasarlar</li>
        <li>Elektrik bağlantı sorunları</li>
        <li>Büyük branda yırtıkları</li>
        <li>Montaj problemleri</li>
      </ul>

      <p>İzmir Tente Tamir olarak, tüm tente arızalarına hızlı ve profesyonel çözümler sunuyoruz. Acil müdahale hizmetimizle yanınızdayız.</p>
    `
  }
];
